// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22":"2d99dbbadf7720fab2ed","71":"349eb3db8a71a8ed361b","452":"7d96be053252971607ab","885":"a0e073753fdc13d4683c","961":"d129d7c95cc2442e3bec"}[chunkId] + ".css";
};